// extracted by mini-css-extract-plugin
export var wordContainer = "_nf-0";